import React from 'react'
import { Container } from 'react-bootstrap'
import { css } from 'emotion'
import { Helmet } from 'react-helmet'
import DriverHeader from 'app/universal/layout/DriverHeader'

const PrintLayout = ({ children, title = "Itinéraires B2C" }) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <style>
          {`
            @media print {
              body {
                margin: 0;
                padding: 0;
                background: white !important;
                color: black !important;
              }
              
              .no-print {
                display: none !important;
              }
              
              .print-only {
                display: block !important;
              }
              
              .container-fluid {
                padding: 0 !important;
                margin: 0 !important;
                max-width: none !important;
              }
              
              .card {
                border: 1px solid #000 !important;
                box-shadow: none !important;
                margin-bottom: 20px !important;
                page-break-inside: avoid;
              }
              
              .card-header {
                background: #f8f9fa !important;
                border-bottom: 1px solid #000 !important;
                font-weight: bold !important;
                color: #000 !important;
              }
              
              .table {
                border-collapse: collapse !important;
              }
              
              .table th,
              .table td {
                border: 1px solid #000 !important;
                padding: 8px !important;
              }
              
              .table thead th {
                background: #f8f9fa !important;
                font-weight: bold !important;
              }
              
              .badge {
                border: 1px solid #000 !important;
                background: white !important;
                color: black !important;
              }
            }
          `}
        </style>
      </Helmet>
      
      <div className={css(styles.printLayout)}>
        <DriverHeader logoutPath="/itineraires-b2c" />
        <Container fluid className={css(styles.container)}>
          {children}
        </Container>
      </div>
    </>
  )
}

const styles = {
  printLayout: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    '@media print': {
      backgroundColor: 'white',
      minHeight: 'auto'
    }
  },
  container: {
    padding: '20px',
    '@media print': {
      padding: '0',
      margin: '0',
      maxWidth: 'none'
    }
  }
}

export default PrintLayout
